import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import Quill from 'quill';

@Component({
  selector: 'app-text-editor',
  templateUrl: './text-editor.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextEditorComponent implements AfterViewInit, OnDestroy, OnChanges {
  @Input() enabled: boolean;
  @Input() initialContent: string;
  @Input() toolbarOptions: unknown[] = [
    ['bold', 'italic', 'underline', 'strike'],
    ['blockquote', 'code-block'],
    [{ header: 1 }, { header: 2 }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ script: 'sub' }, { script: 'super' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ direction: 'rtl' }],
    [{ size: ['small', false, 'large', 'huge'] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ color: [] }, { background: [] }],
    [{ font: [] }],
    [{ align: [] }],
    ['clean'],
  ];
  @Output() valueChanges: EventEmitter<string> = new EventEmitter();
  @ViewChild('editor') private editor: ElementRef;

  private quill: Quill;
  private afterInputContentInit: boolean;

  ngOnChanges(changes: SimpleChanges): void {
    if (this.quill) {
      this.quill.enable(changes.enabled?.currentValue);
    }
  }

  ngAfterViewInit(): void {
    this.createEditor();
    this.setInitialContent();
  }

  ngOnDestroy(): void {
    if (this.quill) {
      this.quill.off('text-change', this.getHTML.bind(this));
    }
  }

  private setInitialContent(): void {
    if (this.initialContent && this.quill && !this.afterInputContentInit) {
      const editorContent = this.quill.getText() || '';
      if (!editorContent.trim()) {
        this.setHTML(this.initialContent);
        this.afterInputContentInit = true;
      }
    }
  }

  private createEditor(): void {
    this.quill = new Quill(this.editor.nativeElement, {
      modules: {
        toolbar: this.toolbarOptions,
      },
      theme: 'snow',
    });
    this.quill.on('text-change', this.getHTML.bind(this));
    this.setInitialContent();
  }

  private getHTML(): string {
    this.valueChanges.emit(this.quill.root.innerHTML);
    return this.quill.root.innerHTML;
  }

  private setHTML(htmlContent: string): void {
    this.quill.root.innerHTML = htmlContent;
  }
}
